module.exports = __webpack_public_path__ + "static/media/status_correcto.9a45bf0c.svg";